import React, { FC, useContext, useEffect, useMemo } from 'react';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { GuestRoutes } from '../../routers/GuestRouter';
import { AuthDialog } from '../AuthDialog/AuthDialog';
import styled from '@mui/styles/styled';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../contexts/AuthContext';
import { AuthenticatedRoutes } from '../../routers/AuthenticatedRoutes';
import { useHistoryWithSearch } from '../../hooks/useHistoryWithSearch';
import { useRouteWithQuery } from '../../hooks/useRouteWithQuery';

const EmailsContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const AuthAccount: FC = () => {
  const { identities, setIdentity } = useContext(AuthContext);
  const { t } = useTranslation();

  const { push: pushWithSearch, replace: replaceWithSearch } = useHistoryWithSearch();

  const uniqueEmails = useMemo(() => identities.map((account) => account.email), [identities]);

  useEffect(() => {
    if (uniqueEmails.length === 0) replaceWithSearch(GuestRoutes.SignIn());
  }, [uniqueEmails]);

  const signInUrl = useRouteWithQuery(GuestRoutes.SignIn, [], { email: null }, true);

  return (
    <AuthDialog
      title={t('auth.account.encouragement')}
      actions={
        <Button component={Link} to={signInUrl} variant="text" color="primary">
          {t('auth.account.useAnother')}
        </Button>
      }
    >
      <EmailsContainer>
        {uniqueEmails.map((email) => {
          return (
            <Button
              key={email}
              onClick={() => {
                const identity = identities.find((id) => id.email === email);
                if (identity) {
                  setIdentity(identity);
                  pushWithSearch(AuthenticatedRoutes.ChooseOrganization());
                }
              }}
              variant="contained"
              color="primary"
            >
              {email}
            </Button>
          );
        })}
      </EmailsContainer>
    </AuthDialog>
  );
};
